module.exports = __webpack_public_path__ + "static/media/Red-282x360.359dfb89.png";